'use client';

import { useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

export interface ToastData {
  id: string;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
}

interface ToastProps {
  toast: ToastData;
  onClose: (id: string) => void;
}

const Toast = ({ toast, onClose }: ToastProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(toast.id);
    }, 4000);

    return () => clearTimeout(timer);
  }, [toast.id, onClose]);

  const typeStyles = {
    success: 'bg-success text-success-foreground',
    error: 'bg-error text-error-foreground',
    warning: 'bg-warning text-warning-foreground',
    info: 'bg-primary text-primary-foreground',
  };

  const typeIcons = {
    success: 'CheckCircleIcon',
    error: 'XCircleIcon',
    warning: 'ExclamationTriangleIcon',
    info: 'InformationCircleIcon',
  };

  return (
    <div
      className={`flex items-center gap-3 rounded-md px-4 py-3 shadow-lg ${typeStyles[toast.type]} animate-slide-in-right`}
      role="alert"
    >
      <Icon name={typeIcons[toast.type] as any} size={24} />
      <p className="flex-1 font-caption text-sm font-medium">{toast.message}</p>
      <button
        onClick={() => onClose(toast.id)}
        className="flex h-6 w-6 items-center justify-center rounded-md transition-colors duration-250 hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2"
        aria-label="Закрыть уведомление"
      >
        <Icon name="XMarkIcon" size={16} />
      </button>
    </div>
  );
};

export default Toast;